if (window.CONFIG.env === "production" || window.CONFIG.env === "testing") {
    const script = document.createElement("script");
    script.src = "//d2wy8f7a9ursnm.cloudfront.net/v7/bugsnag.min.js";
    script.async = true;
    script.onload = () => {
        window.BugsnagClient = Bugsnag.start({
            apiKey: "c3267ff4435e696a857ef4ed7da70f33",
            releaseStage: window.CONFIG.env,
            appVersion: "1.0.0",
            onError: () => {
                return new Promise((resolve) => {
                    if (!window.AGW) {
                        return resolve(true);
                    }

                    window.AGW.hasBlocker().then((res) => {
                        resolve(!res);
                    });
                });
            },
        });
    };
    document.querySelector("head").append(script);
}
